import { Phone } from "react-feather";
import { Modal, ModalBody } from "reactstrap";
import { Href } from "../../../../../../Constants/Constants";
import { dynamicImage, dynamicNumber, Image } from "../../../../../../Utils";
import { setVideoCall } from "../../../../../../ReduxToolkit/Reducers/Messenger/Messenger";
import { useAppDispatch, useAppSelector } from "../../../../../../ReduxToolkit/Hooks";
import { useState } from "react";

const VideoCall= () => {
  const dispatch = useAppDispatch();
  const { videoCall } = useAppSelector((state) => state.messenger)
  const [fullScreen, setFullScreen] = useState(false);

  const fullScreenHandler = (isFullScreen: boolean) => {
    setFullScreen(isFullScreen);
    if (isFullScreen) document.documentElement.requestFullscreen();
    else document?.exitFullscreen();
  };
  return (
    <Modal isOpen={videoCall} fade toggle={() => dispatch(setVideoCall())} centered className="viddiolog">
      <ModalBody>
        <div className="videocall call-modal">
          <Image className="bg-img img-fluid" src={dynamicImage("avtar/big/videocall_bg.jpg")} alt="Avatar" />
          <div className="small-image">
            <Image className="bg-img img-fluid" src={dynamicImage("avtar/big/videocall.jpg")} alt="Avatar" />
          </div>
          <div className="d-flex videocall-details">
            <div className="usersprof">
              {dynamicNumber(2).map((item, index) => (
                <div className="profile" key={index}>
                  <Image className="bg-img img-fluid" src={dynamicImage(`avtar/${item + 1}.jpg`)} alt="Avatar" />
                </div>
              ))}
            </div>
            <div className="media-body">
              <h5>Josephin water</h5>
              <h6>America ,California</h6>
            </div>
            <div>00:00:00</div>
            <div className="zoomcontent">
              <a className="text-dark" href={Href} onClick={() => fullScreenHandler(!fullScreen)}>
                <Image src={dynamicImage("logo/maximize.svg")} alt="zoom screen" />
              </a>
            </div>
          </div>
          <div className="center-con text-center">
            <ul>
              <li><a className="icon-btn btn-light button-effect pause" href={Href}><i className="ti-control-pause" /></a></li>
              <li><a className="icon-btn btn-danger button-effect btn-xl is-animating" href={Href} onClick={() => dispatch(setVideoCall())}><Phone /></a></li>
              <li><a className="icon-btn btn-light button-effect mic" href={Href}><i className="fa fa-microphone" /></a></li>
            </ul>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default VideoCall;
